import { render, staticRenderFns } from "./DxBpas.vue?vue&type=template&id=27df8bf6&scoped=true&"
import script from "./DxBpas.vue?vue&type=script&lang=js&"
export * from "./DxBpas.vue?vue&type=script&lang=js&"
import style0 from "./DxBpas.vue?vue&type=style&index=0&id=27df8bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df8bf6",
  null
  
)

export default component.exports